import { WorkerMessageType } from "./types"
import { getSplitedPath, isRessourceAccepted, log } from "./utils"

declare var self: any

export default (event: any) => {

}
